<template>
  <div>
    <div v-if="detailedMode"
         class="row align-items-center category-detailed-mode mx-3 mt-3 mb-0 rounded position-relative d-flex"
         @click="onItemClick">
      <template v-if="rtlOrientation">
        <div class="col-5 px-4 half-card rounded-left">
          <span v-html="item.title" class="row half-category-title pl-2"/>
          <span v-html="item.desc" class="row mt-3 half-category-description pl-2"/>
        </div>
        <img :src="categoryImage()" class="col-7 p-0 rounded-right">
        <div class="asset-badge fas fa-lock" v-show="isLocked"></div>
      </template>
      <template v-else>
        <img :src="categoryImage()" class="col-7 p-0 rounded-left">
        <div class="col-5 px-4 half-card rounded-right">
          <span v-html="item.title" class="row half-category-title pl-2"/>
          <span v-html="item.desc" class="row mt-3 half-category-description pl-2"/>
        </div>
        <div class="asset-badge fas fa-lock" v-show="isLocked"></div>
      </template>
    </div>
    <div v-else
         class="row position-relative d-flex flex-column mx-2 mt-2 mb-0 rounded"
         @click="onItemClick">
      <img :src="categoryImage()" class="col-12 p-0 rounded">
      <div class="asset-badge fas fa-lock" v-show="isLocked"></div>
  </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  props: ['item', 'promoMode', 'detailedMode', 'rtlOrientation'],
  computed: mapState({
    isRegisteredUser: state => state.isRegisteredUser,
    isLocked: function () {
      const signUpRequired = this.item.flags && this.item.flags.indexOf('SignupRequired') !== -1
      return signUpRequired && !this.isRegisteredUser
    }
  }),
  methods: {
    categoryImage () {
      let baseImage
      if (this.detailedMode) {
        baseImage = this.item.posterSmall
      }
      return baseImage || this.item.backdropSmall || this.item.backdrop || this.item.posterSmall
    },
    onItemClick () {
      if (this.isLocked) {
        this.$store.commit('startSignIn', 'CONTENT_BLOCKED')
        return
      }
      if (this.promoMode) {
        this.$store.commit('navigation/goToPromotedCategory', this.item)
      } else {
        this.$store.commit('navigation/goToCategory', this.item)
      }
    }
  }
}
</script>
